import { SectionItemI } from "../../../shared";
import { StoreWallInterface } from "../../types/store";

//FIXME функция должна делать что то одно. Сейчас функция удаляет всё кроме избранного, тем самым добавляя его.
export const removeSpiritItems = (shelving: StoreWallInterface, itemId?: string, leaveSpirits: boolean = false) => {
    const sections = structuredClone(shelving.sections);

    const getIsSpiritItem = (item: SectionItemI, itemId: string | undefined) => {
        if (!item.isSpirit) {
            return false
        }
        if (item.id === itemId) {
            return false
        }
        return true
    }

    sections.forEach((section, index) => {
        sections[index].items = section.items
            .filter((item) => {
                if (leaveSpirits && itemId) {
                    return true
                } else {
                    return item.isSpirit ? item.id === itemId : true
                }
            })
            .map(((item) => ({
                ...item,
                isSpirit: getIsSpiritItem(item, itemId)
            })))
    })
    return sections;
};
